import DetailsDialog from "./DetailsDialog";

export default DetailsDialog;
